import axios from '@/utils/axios'

export const getCustomerQZUpdateForm = (payload) => {
    return axios.get('/customer_qz_update_form', {
        params: payload
    })
}

export const createCustomerQZUpdateForm = (data) => {
    return axios.post('/customer_qz_update_form', data)
}

export const reviewCustomerQZUpdateForm = (id, data) => {
    return axios.post(`/customer_qz_update_form_review/${id}`, data)
}

export const deleteCustomerQZUpdateForm = (id) => {
    return axios.delete(`/customer_qz_update_form/${id}`)
}

export const removeBannedUserQZ = (data) => {
    return axios.post('/remove_banned_user_qz', data)
}